export const AUTH_COOKIE_NAME = "student_auth_data"
